export const SOUND_DETAILS_VIEW = 'SOUND_DETAILS_VIEW';
export const MULTI_DETAILS_VIEW = 'MULTI_DETAILS_VIEW';
export const SEQUENCER_VIEW = 'SEQUENCER_VIEW';
export const MIX_VIEW = 'MIX_VIEW';
export const PREFERENCES_VIEW = 'PREFERENCES_VIEW';
export const SCRIPTING_VIEW = 'SCRIPTING_VIEW';
export const ARRANGEMENT_VIEW = 'ARRANGEMENT_VIEW';
